import o from "./highrise219.mjs";
/* empty css             */
import t from "./highrise181.mjs";
const f = /* @__PURE__ */ t(o, [["__scopeId", "data-v-d253fa2a"]]);
export {
  f as default
};
